import { FeatureKey, subscriptionCanUseFeature } from 'models';

import { useCurrentTeamSubscription } from './use-current-team-subscription';

export const useFeatureAccess = (feature: FeatureKey) => {
    const teamSubscription = useCurrentTeamSubscription();

    return subscriptionCanUseFeature(teamSubscription, feature);
};

export { FeatureKey };
